export const roboCobrancaVariaveis: Record<string, {
  label: string;
  value: string;
}> = {
  nomeMorador: {
    label: 'Nome do morador',
    value: '%Nome_Morador%'
  },
  cpfMorador: {
    label: 'CPF do morador',
    value: '%CPF_Morador%'
  },
  dataVencimento: {
    label: 'Data de vencimento do boleto',
    value: '%Data_Vencimento%'
  },
  unidade: {
    label: 'Número da unidade',
    value: '%Unidade%'
  },
  condominio: {
    label: 'Nome do condomínio',
    value: '%Condominio%'
  },
  linkBoleto: {
    label: 'Link do boleto',
    value: '%Link_Boleto%',
  },
  valorBoleto: {
    label: 'Valor do boleto',
    value: '%Valor_Boleto%'
  },
}